<template>
  <default-input
    v-if="default_theme"
    type="number"
    :input_props="{min: min_year, max: max_year}"
    :value="value"
    @change="changeYear"
  />
  <search-input
    v-else
    type="number"
    :min="min_year"
    :max="max_year"
    :value="value"
    @change="changeYear"
  />
</template>

<script>

import SearchInput from "../SearchInput.vue";
import DefaultInput from "../DefaultInput.vue";

export default {
  name: "YearInput",
  emits: ["changeYear"],
  components: {DefaultInput, SearchInput},
  props: {
    value: {
      type: Number,
      required: true,
    },
    default_theme: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    min_year() {
      return 1900;
    },
    max_year() {
      return 2100
    },
  },
  data() {
    return {
      selected_month_local: null,
    }
  },
  mounted() {
    this.selected_month_local = this.selected_month
  },
  methods: {
    changeYear({target}) {
      let value = target.value
      if (value > this.max_year) {
        value = this.max_year
      } else if (value < this.min_year) {
        value = this.min_year
      }
      value = Number(value)
      target.value = value
      this.$emit('changeYear', value)
    },
  },
  watch: {
    'selected_month'(val) {
      this.selected_month_local = val;
    }
  }
}
</script>
